import { API_ENDPOINTS } from "@/configs";
import apiRequest from "@/lib/axios";
import { CurrencyOption, WalletCurrencyOption } from "@/types";

export const getCurrencies = async (): Promise<CurrencyOption[]> => {
  return apiRequest({
    method: "GET",
    url: API_ENDPOINTS.CURRENCY.GET_OPTIONS,
    errorMessage: "Failed to load currencies",
  });
};

export const getShowCurrencies = async (): Promise<CurrencyOption[]> => {
  return apiRequest({
    method: "GET",
    url: API_ENDPOINTS.CURRENCY.GET_SHOW_OPTIONS,
    errorMessage: "Failed to load currencies",
  });
};

export const getWalletCurrencies = async (): Promise<WalletCurrencyOption[]> => {
  return apiRequest({
    method: "GET",
    url: API_ENDPOINTS.CURRENCY.GET_WALLET_OPTIONS,
    errorMessage: "Failed to load currencies",
  });
};

export const getCryptoCurrencies = async (): Promise<WalletCurrencyOption[]> => {
  return apiRequest({
    method: "GET",
    url: API_ENDPOINTS.CURRENCY.GET_CRYPTO_OPTIONS,
    errorMessage: "Failed to load currencies",
  });
};
